import { IQuery } from '@/types';
import {
  ISessionQueryResponse,
  ISessionQueryRequest,
  IInitialQueryCardsResponse,
  IRegisterFeedbackRequest,
  IRegisterFeedbackResponse,
} from '@/types/queryTypes';
import { decodeAuthToken } from '@/utils';
import policyGptAxiosInstance from '@/utils/axios/policyGptAxiosInstance';
import { UseMutationOptions } from '@tanstack/react-query';

export const sessionQuery = ({
  context,
  botName,
}: ISessionQueryRequest): IQuery<ISessionQueryResponse | null> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    queryKey: ['session', organisationId, memberId],
    queryFn: async () => {
      if (!organisationId || !memberId || !botName) {
        return null;
      }
      const body = {
        contextValues: context,
      };
      const sessionDetails = await policyGptAxiosInstance.post(
        `/organisation/${organisationId}/member/${memberId}/v2/${botName}/session`,
        body,
      );
      return sessionDetails.data;
    },
  };
};



export const initialQueryCards = (
  botName: string,
): IQuery<IInitialQueryCardsResponse | null> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    queryKey: ['queryCards', organisationId, memberId, botName],
    queryFn: async () => {
      if (!organisationId || !memberId || !botName) {
        return null;
      }
      const chatDetails = await policyGptAxiosInstance.get(
        `/v2/${botName}/get-initial-cards`,
      );
      return chatDetails.data as IInitialQueryCardsResponse;
    },
  };
};

export const registerFeedback = ({
  botName,
}: IRegisterFeedbackRequest): UseMutationOptions<
  IRegisterFeedbackResponse | null,
  Error,
  { feedback: string; conversation_id: string }
> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    mutationKey: ['session', organisationId, memberId],
    mutationFn: async ({
      feedback,
      conversation_id,
    }: {
      feedback: string;
      conversation_id: string;
    }) => {
      if (!organisationId || !memberId || !botName) {
        return null;
      }
      const body = {
        feedback,
      };
      const feedbackResp = await policyGptAxiosInstance.put(
        `/organisation/${organisationId}/member/${memberId}/v2/${botName}/feedback/${conversation_id}`,
        body,
      );
      return feedbackResp.data;
    },
  };
};
